const receiverStatus = {
  CREATED: 'CREATED',
  REMOVED: 'REMOVED'
};

module.exports = receiverStatus;
